import React from 'react';
import { 
  HelpCircle, 
  Clock, 
  Globe, 
  Calendar, 
  Sunrise,
  Phone,
  Briefcase,
  Plane
} from 'lucide-react';

/**
 * Компонент боковой панели с полезными советами о часовых поясах
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: Clock,
      title: 'Московское время',
      description: 'В России часто используют московское время (МСК) как точку отсчета. Оно соответствует UTC+3.'
    },
    {
      icon: Calendar,
      title: 'Летнее время',
      description: 'Россия не переходит на летнее время с 2014 года, что упрощает расчеты времени.'
    },
    {
      icon: Globe,
      title: 'Международные звонки',
      description: 'При планировании звонков всегда указывайте часовой пояс. Например: "15:00 по московскому времени".'
    },
    {
      icon: Sunrise,
      title: 'Джетлаг',
      description: 'При перелёте на восток (увеличение времени) джетлаг переносится тяжелее, чем на запад.'
    },
    {
      icon: Phone,
      title: 'Деловой этикет',
      description: 'Не звоните в другие страны раньше 9:00 и позже 18:00 по их местному времени.'
    },
    {
      icon: Briefcase,
      title: 'Бизнес с Азией',
      description: 'При работе с Китаем, Японией и Кореей планируйте общение на раннее утро по МСК.'
    },
    {
      icon: Plane,
      title: 'Перелёты в РФ',
      description: 'При полёте внутри России обратите внимание на разницу во времени — она может составлять до 9 часов.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-indigo-500" />
        Полезные советы
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-100 dark:border-indigo-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <Globe className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-indigo-700 dark:text-indigo-300 mb-2">
              Знаете ли вы?
            </h4>
            <p className="text-xs text-indigo-600 dark:text-indigo-400 mb-3">
              Россия охватывает 11 часовых поясов — больше, чем любая другая страна мира. Между Калининградом и Камчаткой разница составляет 10 часов.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;